import { Locale, SupportedLocale } from "#/types/Locale"

function withElementFirstIfPresent<T>(array: T[], firstElement: T): T[] {
  const index = array.indexOf(firstElement)
  return index === -1 ? array : [firstElement, ...array.toSpliced(index, 1)]
}

/**
 * Returns enabled locale strings sorted alphabetically with English (U.S.) first.
 * Used by both account settings and header language selector.
 */
export function getSortedEnabledLocaleStrings(enabledLocales: string[]): string[] {
  return withElementFirstIfPresent(enabledLocales.toSorted(), SupportedLocale.English_UnitedStates.toString())
}

/**
 * Maps locale strings to { value, label } for selects/menus.
 * Label uses display name with fallback to the locale code.
 */
export function getLocaleOptionsFromLocaleList(localeStrings: string[]): { value: string; label: string }[] {
  return localeStrings.map((localeString) => ({
    value: localeString,
    label: Locale.getDisplayNameFromString(localeString)
  }))
}
